import { render, staticRenderFns } from "./MypageTemplate.vue?vue&type=template&id=3203503e&"
import script from "./MypageTemplate.vue?vue&type=script&lang=js&"
export * from "./MypageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports